import React, { type FC, type ReactNode } from 'react';

import { Footer } from '@/components/navigations/footer';
import { Header } from '@/components/navigations/header';
import { ClarityScript } from '@/scripts/clarity-script';
import { CookieConsentScript } from '@/scripts/cookie-consent-script';
import { GtmScript } from '@/scripts/gtm-script';
import { HtmlScript } from '@/scripts/html-script';

interface BaseLayoutProps {
    children: ReactNode;
}

export const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
    return (
        <>
            <div className="ultra-wide-container">
                <Header />
                <main>{children}</main>
                <Footer />
            </div>

            <HtmlScript />
            <GtmScript />
            <CookieConsentScript />
            <ClarityScript />
        </>
    );
};
